import React from 'react'

const VOIndexRegister = () => {
    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card" id={1}>
                    <div className="card-body">
                        <div className="checklist-title-bx">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="text-center">
                                        <h4>(P) VO INDEX REGISTER</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*<div class="row">
                                
										  <div class="col-md-12 ">
										     <div class="report-index-top">
											    <table>
												  <tr>
												  <td class="hd-s2"><p>Yard</p></td>
												  <td class="td-input-bx">
												  <div class="hull-select-box">
													   <select class="form-select">
														  <option>Select Yard Number</option>
														  <option>CL-001</option>
														  <option>CL-002</option>
														  <option>CL-003</option>
														  <option>CL-004</option>
													   </select>
													
													</div>
												</td>
												  <td class="hd-s2 pl10"><p>Hull No</p></td>
												  <td class="td-input-bx">
												  <div class="hull-select-box">
													   <select class="form-select">
														  <option>Select Hull Number</option>
														  <option>CL-001</option>
														  <option>CL-002</option>
														  <option>CL-003</option>
														  <option>CL-004</option>
													   </select>
													
													</div>
													
													</td>
												  <td class="hd-s2 pl10"><p>Owner</p></td>
												  <td class="td-input-bx"><input type="text" class="form-control" placeholder="Enter Owner Name" value=""></td>

												  
												  </tr>
												
												</table>
											   
											 </div>
										  </div>
										 </div>*/}
                        <div className="row">
                            <div className="col-md-12 ">
                                <div className="appraisal-report-table-responsive">
                                    <table className="assessment-table voindextable" cellSpacing={0}>
                                        <tbody>
                                            <tr>
                                                <td className="hd-s2 pd10">
                                                    {" "}
                                                    <p>S.No.</p>
                                                </td>
                                                <td className="hd-s2 pd10 w150">
                                                    <p>Date Issued</p>
                                                </td>
                                                <td className="hd-s1 pd10 w100">
                                                    <p>(P) VO number</p>
                                                </td>
                                                <td className="hd-s2 pd10 w150">
                                                    <p>Originator Yard/Owner</p>
                                                </td>
                                                <td className="hd-s2 pd10">
                                                    <p>Subject </p>
                                                </td>
                                                <td className="hd-s2 pd10 w100">
                                                    <p>Est Cost in USD</p>
                                                </td>
                                                <td className="hd-s2 pd10 w100">
                                                    <p>Approved date</p>
                                                </td>
                                                <td className="hd-s2 pd10 w100">
                                                    <p>Agreed Cost in USD</p>
                                                </td>
                                                <td className="hd-s2 pd10 w100">
                                                    <p>Time Impact (in days)</p>
                                                </td>
                                                <td className="hd-s2 pd10 w100">
                                                    <p>Remarks</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">1.</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">2.</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">3.</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">4.</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">5.</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="td-s1">
                                                    <p className="s1">6.</p>
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                                <td className="tb-input-value">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder=""
                                                        defaultValue=""
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan={4} className="td-s1 hd-s2 pd10 pr15">
                                                    <p className="text-right ">Total Cost (USD)</p>
                                                    <p />
                                                </td>
                                                <td className="hd-s2 pd10">
                                                    <p>
                                                        <span className="red">$0.00</span>
                                                    </p>
                                                </td>
                                                <td className="td-s1 pd10 hd-s2 pr15" colSpan={2}>
                                                    <p className="text-right ">Total delay (days) </p>
                                                </td>
                                                <td className="hd-s2 pd10" colSpan={3}>
                                                    <p>
                                                        <span className="red">0</span>
                                                    </p>
                                                </td>
                                            </tr>
                                            <tr className="addmoreitem">
                                                <td className="td-s1" colSpan={10}>
                                                    <button type="button" className="btn btn-link">
                                                        + Add New Item
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                {/*<div class="row mt-4">
													<div class="col-lg-12 text-left ">
													 <table class="table-bottom-sig">
														  <tbody>
															<tr class="bottom-sig-tr2-box">
															  
																	
																<td class="input-td">
																 
																   <p class="s2">Signature of Site Manager:</p>
																</td>
																<td>
																<p class="s1"><input type="text" class="form-control" placeholder="" value=""></p>
																</td>
																
																</tr>
																
															
														  </tbody></table>
													</div>
													</div>*/}
                                <div className="row mt-4">
                                    <div className="col-lg-12 text-left ">
                                        <a
                                            href="ship-inspection-progress-list.php"
                                            className="btn btn-success"
                                            style={{
                                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                                borderColor: "#2b5a7e"
                                            }}
                                        >
                                            Submit
                                        </a>
                                        <button
                                            type="reset"
                                            className="btn btn-danger ms-3"
                                            style={{
                                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                                borderColor: "#2b5a7e"
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default VOIndexRegister